export const hasMultipleLocations = rest => {
  if (!rest || !rest.locations) {
    return false;
  }
  return rest.locations.length > 1;
};
